import * as actions from './umoSortActionTypes';
import piction from '../utils/piction';
import { SESSION_EXPIRED_MESSAGE } from '../constants/sessionStateTypes';
import { sessionExpired } from './session';

export const addToSortLightboxRequest = () => ({
  type: actions.ADD_TO_SORT_LIGHTBOX_REQUEST,
});

export const addToSortLightboxSuccess = res => ({
  type: actions.ADD_TO_SORT_LIGHTBOX_SUCCESS,
  res,
});

export const addToSortLightboxFailure = error => ({
  type: actions.ADD_TO_SORT_LIGHTBOX_FAILURE,
  error,
});

// for every category being sorted- it needs to run add_all_to_lightbox
export const addToSortLightbox = catID =>
  function addToSortLightboxDispatch(dispatch) {
    dispatch(addToSortLightboxRequest());

    const callArgs = { CATEGORY_ID: catID };

    const promise = piction.request('ADD_TO_LIGHTBOX_ALL', callArgs);

    promise
      .then((res) => {
        if (res && res.RETURN_MESSAGE && res.RETURN_MESSAGE === 'TRUE') {
          dispatch(addToSortLightboxSuccess(res));
          return res.RETURN_MESSAGE;
        }
        if (res.message && res.message.includes(SESSION_EXPIRED_MESSAGE)) {
          throw new Error(res);
        } else {
          throw new Error('Invalid response');
        }
      })
      .catch((error) => {
        if (error.message && error.message.includes(SESSION_EXPIRED_MESSAGE)) {
          dispatch(sessionExpired(error));
        } else {
          dispatch(
            addToSortLightboxFailure(error)
          );
        }
        return error;
      });
    return promise;
  };



// WEBPACK FOOTER //
// ./src/js/actions/umoSort.js